import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-master-delivery-route-dropdown',
  templateUrl: './MasterDeliveryRouteDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => MasterDeliveryRouteDropdownComponent)}]
})
export class MasterDeliveryRouteDropdownComponent extends BaseDropdownComponent {

    public salesOfficeNumber: string;

    constructor(private domainDataService: serv.DomainDataService) 
    { 
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        //2022-10-01 LEB: do not call getMasterDeliveryRoutes here; it will undo anything loaded in loadOnDemand
        //this.domainDataService.getMasterDeliveryRoutes().then(x=> this.onGetRecordsDone(x, ''));
    }

    public loadOnDemand(salesOfficeNumber: string, distributionChannel: string){

        this.salesOfficeNumber = salesOfficeNumber;
        this.domainDataService.getMasterDeliveryRoutes().subscribe(x=> this.onGetRecordsDone(x, distributionChannel));

    }
    
    onGetRecordsDone(items: ent.MasterDeliveryRoute[], distributionChannel: string){
        this.selectItems = [];
        this.selectItems.push({label:"", value:Constants._NONE});

        _.remove(items, x=>x.Inactive == true);
        _.remove(items, x=>x.DistributionChannel != distributionChannel);
        if (this.salesOfficeNumber){
            _.remove(items, x=>x.SalesOfficeNumber != this.salesOfficeNumber);
        }
        items.forEach(y=> this.selectItems.push({label:y.Code, value:y.ID}));
        if (this.selectedID){
            this.value = this.selectedID;
        }
    }

}